<script setup lang="ts">
import RankedNetwork from '~/components/Networks/RankedNetwork.vue'
import useNetworkStore from '~/store/network'

const networkStore = useNetworkStore()
</script>

<template>
    <div
        class="px-4 md:px-16 lg:px-20 py-6 md:py-12 bg-white flex flex-col justify-center items-center gap-2 md:gap-2.5"
    >
        <img
            class="w-64"
            :src="`${useRuntimeConfig().app.cdnURL}/images/CleanStation.svg`"
            :alt="$t('networks.ranking_title')"
        />
        <h2>
            {{ $t('networks.ranking_title') }}
        </h2>
        <span>
            {{ $t('networks.ranking_subtitle') }}
        </span>
        <div class="flex flex-wrap justify-center items-center gap-2 md:gap-5">
            <div
                v-for="network in networkStore.rankedNetworks"
                :key="network.id"
            >
                <RankedNetwork
                    :network
                    :rating="
                        networkStore.getRatingFromCommunityFeedbacks(network)
                    "
                />
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
h2 {
    @apply text-center text-2xl md:text-4xl leading-normal md:leading-10 mx-4;
}

span {
    @apply text-center text-zinc-500 text-base font-normal font-inter leading-tight md:max-w-[510px] pb-1 md:pb-4.5;
}
</style>
